import crypto from "crypto-js"

/**
 * 2019-08-06
 * @param { 将时间对象转换成字符串 } date
 */
export function formatDate(date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    let minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    let second= date.getSeconds();
    second = minute < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d;
};



/**
 * 2019-9
 * @param {时间} date
 */
export function formatDate_Year(date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    let minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    let second= date.getSeconds();
    second = minute < 10 ? ('0' + second) : second;
    return y + '-' + m;
};

export function formatDate_Year_(date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    let minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    let second= date.getSeconds();
    second = minute < 10 ? ('0' + second) : second;
    return y;
};



/**
 *
 * @param { 将时间字符串转换成日期对象 } date
 */
export function parserDate (date) {
    let t = Date.parse(date);
    if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, "/")));
    } else {
        return new Date();
    }
};


//返回详细时间文本格式
export function formatDateToString(date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    let second= date.getSeconds();
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

/**
 * 返回 12:30
 * @param {时间} date
 */
export function formatDateMin(date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    let minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    let second= date.getSeconds();
    second = minute < 10 ? ('0' + second) : second;
    return h + ':' + minute;
};

export async function sha256(message) {
  /*// 将字符串转换为Uint8Array
  const msgBuffer = new TextEncoder().encode(message);
  // 使用SubtleCrypto进行哈希计算
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  // 将ArrayBuffer转换为十六进制字符串
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;*/

  // 使用 SHA-256 计算哈希值
  const hash = crypto.SHA256(message);
  // 将哈希值转换为十六进制字符串
  return hash.toString(crypto.enc.Hex);
};



// WEBPACK FOOTER //
// ./src/utilities.js